const currencyFormat = ['en-GB', { style: 'currency', currency: 'GBP' }];

/* eslint eqeqeq: 0 */
export default class StringFormatHelper {
    static formatToCurrency(number) {
        if (number == null || number === '' || isNaN(parseInt(number))) {
            return '';
        }

        const replacement = /\.\d{2}$/;
        let formattedNumber = Number(Math.round(number)).toLocaleString(...currencyFormat);

        if (formattedNumber && formattedNumber.indexOf('£') < 0) {
            formattedNumber = `£${Number(Math.round(number)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
        }

        return formattedNumber.replace(replacement, '');
    }

    static formatToNumber(currency) {
        let currencyToNumber = currency.toString().replace(/£/g, '').replace(/\,/g, '');
        currencyToNumber = isNaN(parseInt(currencyToNumber)) ? '' : parseInt(currencyToNumber);
        return currencyToNumber;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/StringFormatHelper.js